import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login, loginDistribuidor } from "../services/api";
import { persistAuthExtras } from "../utils/permissoes";
import { portalDistribuidor } from "../utils/portalModo";
import { Eye, EyeOff, Mail, Lock } from "lucide-react";

const Login = ({ setToken, setUserName }) => {
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState("");

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro("");
    setLoading(true);

    try {
      const fn = portalDistribuidor() ? loginDistribuidor : login;
      let response;
      try {
        response = await fn({ email, senha });
      } catch (error) {
        if (!portalDistribuidor() && error?.response?.status === 404) {
          response = await loginDistribuidor({ email, senha });
        } else {
          throw error;
        }
      }
      const { token, userName, permissoes, perfil, tipo } = response.data;

      sessionStorage.setItem("token", token);
      sessionStorage.setItem("userName", userName);
      if (tipo) sessionStorage.setItem("portalTipo", tipo);
      else sessionStorage.removeItem("portalTipo");
      persistAuthExtras({ permissoes, perfil });

      setToken(token);
      setUserName(userName);

      navigate("/home");
    } catch (error) {
      console.error("Erro ao fazer login", error);

      const data = error?.response?.data;

      // 1) quando backend manda string (text/plain)
      if (typeof data === "string") {
        setErro(data);
      }
      // 2) quando backend manda JSON { message } ou ModelState
      else if (data && typeof data === "object") {
        const msg =
          data?.message ||
          data?.Message ||
          (data?.errors && Object.values(data.errors).flat().join("\n")) ||
          (data?.Errors && Object.values(data.Errors).flat().join("\n"));

        setErro(msg || "Erro ao fazer login.");
      }
      // 3) fallback (sem resposta / rede / etc)
      else {
        setErro("Credenciais inválidas. Tente novamente.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-vh-100 d-flex justify-content-center align-items-center"
      style={{
        background: "linear-gradient(135deg, #0f172a, #1e293b, #020617)",
      }}
    >
      <div
        className="card shadow-lg border-0 p-4 text-white"
        style={{
          maxWidth: 420,
          width: "100%",
          borderRadius: 16,
          background: "rgba(255,255,255,0.08)",
          backdropFilter: "blur(12px)",
        }}
      >
        {/* Logo */}
        <div className="flex flex-col items-center mb-6">
          <img
            src="/logo-branco.png"
            alt="Zen Software"
            className="h-14 mb-2"
          />
          <p className="text-white-50 small mb-0">
            Painel da Revenda
          </p>
        </div>

        {erro && (
          <div className="alert alert-danger py-2 text-center">
            {erro}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          {/* Email */}
          <div className="mb-3">
            <label className="form-label text-white-50">Email</label>
            <div className="input-group">
              <span className="input-group-text bg-dark border-0 text-white-50">
                <Mail size={18} />
              </span>
              <input
                type="email"
                className="form-control bg-dark text-white border-0"
                placeholder="seu@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
              />
            </div>
          </div>

          {/* Senha */}
          <div className="mb-4">
            <label className="form-label text-white-50">Senha</label>
            <div className="input-group">
              <span className="input-group-text bg-dark border-0 text-white-50">
                <Lock size={18} />
              </span>
              <input
                type={mostrarSenha ? "text" : "password"}
                className="form-control bg-dark text-white border-0"
                placeholder="••••••••"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                required
              />
              <button
                type="button"
                className="input-group-text bg-dark border-0 text-white-50"
                onClick={() => setMostrarSenha(!mostrarSenha)}
              >
                {mostrarSenha ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-primary w-100 py-2 fw-semibold"
            disabled={loading}
          >
            {loading ? "Entrando..." : "Entrar"}
          </button>
        </form>

        <div className="text-center mt-4">
          <small className="text-white-50">
            © {new Date().getFullYear()} Zen Software
          </small>
        </div>
      </div>
    </div>
  );
};

export default Login;
